import BaseListStore from 'stores/BaseListStore';
import ScheduledReportStore, { IScheduledReport } from 'stores/report/ScheduledReportStore';
import { IDataFetchOptions } from '../../types';
import { destroy, get, getPage, patch, post, getCount } from 'stores/_services/dataService';
import { getConditions } from 'stores/_services/filterService';

export default class ScheduledReportListStore extends BaseListStore<ScheduledReportStore> {
    constructor() {
        super({
            itemStore: ScheduledReportStore
        });
    }

    async getReports(args: IDataFetchOptions = {}, pageNumber = 1, pageSize = 25): Promise<void> {
        const shouldReset = this._updateListState(args);
        const conditions = getConditions(this.filter);

        const options = {
            filter: {
                limit: pageSize,
                skip: (pageNumber - 1) * pageSize,
                order: this.sort
            },
            includeFields: ['id', 'name', 'createdOn']
        };

        const { data } = await getPage('scheduledReports', options);
        const totalCount = await getCount('scheduledReports', { where: conditions });

        if (shouldReset) {
            this.clearIds();
        }

        this._updateData(data);
        this._updateIds(data, 0);
        this.count = data.length;
        this.totalCount = totalCount;
        this.page = pageNumber;
    }

    async getReport(reportId: string): Promise<void> {
        const { data } = await get(`scheduledReports/${reportId}`);
        this._updateData(data);
    }

    async deleteReport(reportId: string): Promise<void> {
        if (!reportId) return;

        const { data } = await destroy(`scheduledReports/${reportId}`);

        this._updateData(data);
    }

    async saveReport(report: IScheduledReport): Promise<void> {
        if (report.id) {
            report.updatedOn = new Date();

            const res = await patch(`scheduledReports/${report.id}`, report);
            this.getReports({ reset: true });
        } else {
            await post('scheduledReports', report);
            this.getReports({ reset: true });
        }
    }
}
